import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LogoTitle from '../../assets/images/logo-s.png';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './logo/index';
import Loader from 'react-loaders'

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const nameArray = ['f', 'o', 'r', 'm', 'e', 'h'];
    const descArray = [
        'Y', 'o', 'u', 'r', ' ', 'F', 'r', 'i', 'e', 'n', 'd', 'l', 'y', ' ',
        'N', 'e', 'i', 'g', 'h', 'b', 'o', 'u', 'r', 'h', 'o', 'o', 'd', ' ',
        'T', 'e', 'c', 'h', '-', 'B', 'r', 'o'
    ];

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 6000);
    
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);
    

    return (
        <>
        <div className='container home-page'>
            <div className='text-zone'>
                <h1>
                    <span className={letterClass}>H</span>
                    <span className={`${letterClass} _12`}>i,</span>
                    <br />
                    <span className={`${letterClass} _13`}>I</span>
                    <span className={`${letterClass} _14`}>'m</span>
                    <img src={LogoTitle} alt='developer' />
                    <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={15} />
                    <br />
                    <AnimatedLetters letterClass={letterClass} strArray={descArray} idx={21} />
                </h1>
                <h2>Fullstack Developer | DevOps Engineer | Multifaceted Tech Enthusiast | A Hooper</h2>
                <Link to='/contact' className='flat-button'>CONTACT ME</Link>
            </div>
            <Logo/>
        </div>
        <Loader type="pacman" />
        </>
    );
};

export default Home;
